import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  routes: [
    // 仪表板
    {
      path: '/',
      name: 'Dashboard',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/dashBoard'], resolve)
    },
    // 直佣解冻
    {
      path: '/straightCommission',
      name: 'StraightCommission',
      meta: {
        menu: '/straightCommission',
        keep: true    // 缓存
      },
      component: resolve => require(['@/pages/straightCommission'], resolve),
    },
    {
      // 直佣解冻详情
      path: '/straightCommissionDetail',
      name: 'straightCommissionDetail',
      meta: {
        menu: '/straightCommission'
      },
      component: resolve => require(['@/pages/straightCommission/detail'], resolve)
    },
    // 直佣异常
    {
      path: '/straightAbnormal',
      name: 'StraightAbnormal',
      meta: {
        menu: '/straightAbnormal',
        keep: true    // 缓存
      },
      component: resolve => require(['@/pages/straightAbnormal'], resolve),
    },
    // 直佣异常详情页
    {
      path: '/straightAbnormalDetail',
      name: 'StraightAbnormalDetail',
      meta: {
        menu: '/straightAbnormal'
      },
      component: resolve => require(['@/pages/straightAbnormal/detail'], resolve),
    },
    // 发佣启动
    {
      path: '/CommissionStart',
      name: 'CommissionStart',
      meta: {
        menu: '/CommissionStart'
      },
      component: resolve => require(['@/pages/commissionStart'], resolve)
    },
    // 营业部架构确认
    {
      path: '/saleframecomfirm',
      name: 'Saleframecomfirm',
      meta: {
        menu: '/saleframecomfirm'
      },
      component: resolve => require(['@/pages/saleframecomfirm'], resolve),
    },
    // 营业部架构检查
    {
      path: '/resaleframecomfirm',
      name: 'Resaleframecomfirm',
      meta: {
        menu: '/saleframecomfirm'
      },
      component: resolve => require(['@/pages/saleframecomfirm/resaleframecomfirm'], resolve),
    },
    // 省架构确认
    {
      path: '/provinceframecomfirm',
      name: 'Provinceframecomfirm',
      meta: {
        menu: '/provinceframecomfirm'
      },
      component: resolve => require(['@/pages/provinceframecomfirm'], resolve),
    },
    // 营业部保单确认
    {
      path: '/saleguaranteecomfirm',
      name: 'Saleguaranteecomfirm',
      meta: {
        menu: '/saleguaranteecomfirm'
      },
      component: resolve => require(['@/pages/saleguaranteecomfirm'], resolve),
    },
    // 营业部-发佣保单列表
    {
      path: '/saleguaranteeList',
      name: 'SaleguaranteeList',
      meta: {
        menu: '/saleguaranteecomfirm'
      },
      component: resolve => require(['@/pages/saleguaranteecomfirm/list'], resolve),
    },
    {
      // 营业部-发佣保单详情
      path: '/saleguaranteeDetail',
      name: 'saleguaranteeDetail',
      meta: {
        menu: '/saleguaranteecomfirm'
      },
      component: resolve => require(['@/pages/saleguaranteecomfirm/detail'], resolve)
    },
    // 省保单确认
    {
      path: '/provinceguaranteecomfirm',
      name: 'Provinceguaranteecomfirm',
      meta: {
        menu: '/provinceguaranteecomfirm'
      },
      component: resolve => require(['@/pages/provinceguaranteecomfirm'], resolve),
    },
    // 省保单确认-发佣保单列表
    {
      path: '/provinceGuaranteeList',
      name: 'ProvinceGuaranteeList',
      meta: {
        menu: '/provinceguaranteecomfirm'
      },
      component: resolve => require(['@/pages/provinceguaranteecomfirm/list'], resolve),
    },
    {
      // 省保单确认-发佣保单详情
      path: '/provinceGuaranteeDetail',
      name: 'provinceGuaranteeDetail',
      meta: {
        menu: '/provinceguaranteecomfirm'
      },
      component: resolve => require(['@/pages/provinceguaranteecomfirm/detail'], resolve)
    },
    {
      // 加扣款导入
      path: '/adImport',
      name: 'adImport',
      meta: {
        menu: '/adImport'
      },
      component: resolve => require(['@/pages/adImport'], resolve)
    },
    {
      // 加扣款导入-导入文件
      path: '/adImportNow',
      name: 'adImportNow',
      meta: {
        menu: '/adImport'
      },
      component: resolve => require(['@/pages/adImport/import'], resolve)
    },
    {
      // 加扣款导入-查看明细
      path: '/adImportList',
      name: 'adImportList',
      meta: {
        menu: '/adImport'
      },
      component: resolve => require(['@/pages/adImport/list'], resolve)
    },
    {
      // 加扣款确认
      path: '/adConfirm',
      name: 'adConfirm',
      meta: {
        menu: '/adConfirm'
      },
      component: resolve => require(['@/pages/adConfirm'], resolve)
    },
    {
      // 加扣款确认-查看明细
      path: '/adConfirmList',
      name: 'adConfirmList',
      meta: {
        menu: '/adConfirm'
      },
      component: resolve => require(['@/pages/adConfirm/list'], resolve)
    },
    // 佣金计算
    {
      path: '/commissioncount',
      name: 'Commissioncount',
      component: resolve => require(['@/pages/commissioncount'], resolve),
      meta: {
        menu: '/commissioncount'
      },
    },
    // 佣金计算-结果列表
    {
      path: '/calculateCommission',
      name: 'CalculateCommission',
      meta: {
        menu: '/commissioncount'
      },
      component: resolve => require(['@/pages/commissioncount/list'], resolve),
    },
    {
      // 佣金计算-发佣保单详情
      path: '/calculateCommissionDetail',
      name: 'calculateCommissionDetail',
      meta: {
        menu: '/commissioncount'
      },
      component: resolve => require(['@/pages/commissioncount/detail'], resolve)
    },
    // 佣金计算-算佣保单列表
    {
      path: '/commissionResultList',
      name: 'CommissionResultList',
      meta: {
        menu: '/commissioncount'
      },
      component: resolve => require(['@/pages/commissioncount/resultList'], resolve),
    },
    {
      // 佣金计算-算佣明细
      path: '/calculateDetail',
      name: 'calculateDetail',
      meta: {
        menu: '/commissioncount'
      },
      component: resolve => require(['@/pages/commissioncount/calDetail'], resolve)
    },
    // 省人管确认
    {
      path: '/provincemanagecomfirm',
      name: 'Provincemanagecomfirm',
      meta: {
        menu: '/provincemanagecomfirm'
      },
      component: resolve => require(['@/pages/provincemanagecomfirm'], resolve),
    },
    // 省人管确认---发佣详情列表
    {
      path: '/provinceCommissionDetail',
      name: 'ProvinceCommissionDetail',
      meta: {
        menu: '/provincemanagecomfirm'
      },
      component: resolve => require(['@/pages/provincemanagecomfirm/list'], resolve),
    },
    {
      // 省人管确认 --发佣明细
      path: '/provincemanagecomfirmDetail',
      name: 'provincemanagecomfirmDetail',
      meta: {
        menu: '/provincemanagecomfirm'
      },
      component: resolve => require(['@/pages/provincemanagecomfirm/detail'], resolve)
    },
    {
      // 省财务确认
      path: '/provincefinancecomfirm',
      name: 'Provincefinancecomfirm',
      meta: {
        menu: '/provincefinancecomfirm'
      },
      component: resolve => require(['@/pages/provincefinancecomfirm'], resolve),
    },
      // 省财务确认 --- 发佣详情列表
    {
      path: '/profincomdetail',
      name: 'Profincomdetail',
      meta: {
        menu: '/provincefinancecomfirm'
      },
      component: resolve => require(['@/pages/provincefinancecomfirm/list'], resolve),
    },
    {
      // 省财务确认 --发佣详情
      path: '/provincefinancecomfirmDetail',
      name: 'provincefinancecomfirmDetail',
      meta: {
        menu: '/provincefinancecomfirm'
      },
      component: resolve => require(['@/pages/provincefinancecomfirm/detail'], resolve)
    },
    // 总部人管确认
    {
      path: '/headquartermanagecomfirm',
      name: 'Headquartermanagecomfirm',
      meta: {
        menu: '/headquartermanagecomfirm'
      },
      component: resolve => require(['@/pages/headquartermanagecomfirm'], resolve),
    },
    // 总部人管确认 --发佣详情列表
    {
      path: '/headmancomdetail',
      name: 'Headmancomdetail',
      meta: {
        menu: '/headquartermanagecomfirm'
      },
      component: resolve => require(['@/pages/headquartermanagecomfirm/list'], resolve),
    },
    {
      // 总部人管确认   --发佣详情
      path: '/headquartermanagecomfirmDetail',
      name: 'headquartermanagecomfirmDetail',
      meta: {
        menu: '/headquartermanagecomfirm'
      },
      component: resolve => require(['@/pages/headquartermanagecomfirm/detail'], resolve)
    },
    {
      // 总部财务确认
      path: '/headquarterfinancecomfirm',
      name: 'Headquarterfinancecomfirm',
      meta: {
        menu: '/headquarterfinancecomfirm'
      },
      component: resolve => require(['@/pages/headquarterfinancecomfirm'], resolve),
    },
    {
      // 总部财务确认 --发佣详情列表
      path: '/headfincomdetail',
      name: 'Headfincomdetail',
      meta: {
        menu: '/headquarterfinancecomfirm'
      },
      component: resolve => require(['@/pages/headquarterfinancecomfirm/list'], resolve),
    },
    {
      // 总部财务确认 --发佣详情
      path: '/headquarterfinancecomfirmDeail',
      name: 'headquarterfinancecomfirmDeail',
      meta: {
        menu: '/headquarterfinancecomfirm'
      },
      component: resolve => require(['@/pages/headquarterfinancecomfirm/detail'], resolve)
    },
    {
      // 渠道佣金
      path: '/channelCommission',
      name: 'ChannelCommission',
      meta: {
        menu: '/channelCommission',
        keep: true    // 缓存
      },
      component: resolve => require(['@/pages/channelCommission'], resolve),
    },
    {
      // 渠道佣金详情
      path: '/channelCommissionDetail',
      name: 'channelCommissionDetail',
      component: resolve => require(['@/pages/channelCommission/detail'], resolve)
    },
    {
      // 加扣款查询
      path: '/adQuery',
      name: 'adQuery',
      meta: {
        menu: '/adQuery',
        keep: true    // 缓存
      },
      component: resolve => require(['@/pages/adQuery'], resolve)
    },
    {
      // 佣金明细表查询
      path: '/commissionDetailQuery',
      name: 'commissionDetailQuery',
      meta: {
        menu: '/commissionDetailQuery',
        keep: true    // 缓存
      },
      component: resolve => require(['@/pages/commissionDetailQuery'], resolve)
    },
    {
      // 佣金明细表查询 ---详情
      path: '/commissionDetail',
      name: 'commissionDetail',
      meta: {
        menu: '/commissionDetailQuery'
      },
      component: resolve => require(['@/pages/commissionDetailQuery/detail'], resolve)
    },
    {
      // 算佣保单列表
      path: '/commissionPolicy',
      name: 'commissionPolicy',
      meta: {
        menu: '/commissionPolicy',
        keep: true    // 缓存
      },
      component: resolve => require(['@/pages/commissionPolicy'], resolve)
    },
    {
      // 算佣保单详情
      path: '/commissionPolicyDetail',
      name: 'commissionPolicyDetail',
      meta: {
        menu: '/commissionPolicy'
      },
      component: resolve => require(['@/pages/commissionPolicy/detail'], resolve)
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js